<!--
 * @Descripttion: 大屏设计器
 * @Author: leo.liu
 * @Date: 2021-3-13 11:04:24
 * @Last Modified by:   leo.liu
 * @Last Modified time: 2021-3-13 11:04:24
 !-->
<template>
  <div class="layout">
    <div
      v-if="toolIsShow"
      class="layout-left"
      :style="{
        flex: '0 0 ' + widthLeftForTools + 'px',
        width: widthLeftForTools + 'px',
      }"
    >
      <!-- <a-tabs type="card" > -->
      <!-- 左侧组件栏-->
      <div class="cont-tool-bar">
        <span class="tool-bar second-title">工具栏</span>
      </div>
      <draggable
        v-for="widget in widgetTools"
        :key="widget.code"
        @end="(evt) => widgetOnDragged(evt, widget.code)"
      >
        <div class="tools-item" :style="dateDisabled(widget)">
          <span class="tools-item-icon">
            <icon-font :type="widget.icon" />
          </span>
          <span class="tools-item-text">{{ widget.label }}</span>
        </div>
      </draggable>
      <!-- </a-tab-pane> -->
      <!-- 左侧图层-->
      <div style="position: absolute; z-index: -1">
        <draggable
          :options="{ animation: 300 }"
        >
        </draggable>
      </div>
    </div>

    <div
      class="layout-left-fold"
      :style="{
        flex: '0 0 ' + widthLeftForToolsHideButton + 'px',
        width: widthLeftForToolsHideButton + 'px',
      }"
      @click="toolIsShow = !toolIsShow"
    >
      <i v-show="toolIsShow" class="el-icon-arrow-right" />
      <i v-show="!toolIsShow" class="el-icon-arrow-left" />
    </div>

    <div
      class="layout-middle"
      ref="layout-middle"
      :style="{
        height: 'calc(100vh - 112px)',
        'width': '500px',
        'overflow-x': zoom>100?'auto':'hidden',
        'overflow-y': 'scroll'
      }"
    >
      <div
        class="workbench-container"
        :style="{
          height: 'calc(100vh - 114px)',
          maxWidth: `${middleWidth*zoom/100}px`,
        }"
        @mousedown="handleMouseDown"
        ref="workbench-container"
      >
        <div
          id="workbench"
          class="workbench"
          :class="dashboard.style === 'dark'?'workbench-dark':''"
          ref="workbench"
          :style="{
            transform: workbenchTransform,
            width: workbenchWidth,
            height: scrollHeight / bigscreenScaleInWorkbench + 'px',
            'background-color': dashboard.backgroundColor,
            'background-image': 'url(' + dashboard.backgroundImage + ')',
            'background-position': '0% 0%',
            'background-size': '100% 100%',
            'background-repeat': 'initial',
            'background-attachment': 'initial',
            'background-origin': 'initial',
            'background-clip': 'initial',
            zoom: this.zoom/100
          }"
          @click.self="setOptionsOnClickScreen"
        >
          <widget
            ref="widgets"
            v-for="(widget, index) in widgets"
            :key="index"
            v-model="widget.value"
            :batchFlag="batchFlag"
            :index="index"
            :step="step"
            :type="widget.type"
            :options="widgetOptions"
            :widgetValueChanged="widgetValueChanged"
            :bigscreen="{ bigscreenWidth, bigscreenHeight }"
            :batchList="batchList"
            :widgets="widgets"
            :widgetIndex="widgetIndex"
            @batchListChange="batchList=$event"
            @timeChange="timeChange"
            @onActivated="widgetsOnActivated"
            @contextmenu.prevent.native="rightClick($event, index, widget)"
          />
          <div class="line" v-for="i in Math.floor(bigscreenWidth/20 - 1)" :key="'l'+ i" :style="{
            left: `${i*20}px`,
            background: i%5===0?'#ccc':'#eee',
            height: scrollHeight/zoom*100 + 'px'
          }" ></div>
          <div class="ve-line" v-for="i in Math.floor(scrollHeight/zoom*100/20)" :key="'v'+ i" :style="{
            top: `${i*20}px`,
            background: i%5===0?'#ccc':'#eee',
          }" ></div>
        </div>
      </div>
    </div>

    <div
      class="layout-right"
      :style="{
        flex: '0 0 ' + widthLeftForOptions + 'px',
        width: widthLeftForOptions + 'px',
      }"
    >
      <div v-if="batchFlag">
        <a-tabs activeKey="first" type="card" class="config-tab">
          <a-tab-pane :forceRender="true" key="first" tab="位置调整">
            <div style="display:inline-block;position:absolute;right: 0;top:7px">
              <a-button size="small" type="link" @click="batchList = [...(new Array(widgets.length)).keys()]">全选</a-button>
              <a-button size="small" type="link" @click="batchList = []">取消全选</a-button>
            </div>
            <div class="postion-btns">
              <div class="line"></div>
              <div class="vline"></div>
              <a-button class="left" @click="batchMove('left', 20, false)">左移20px</a-button>
              <a-button class="right" @click="batchMove('left', -20, true)">右移20px</a-button>
              <a-button class="top" @click="batchMove('top', 20, false)">上移20px</a-button>
              <a-button class="bottom" @click="batchMove('top', -20, false)">下移20px</a-button>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <a-tabs v-model:activeKey="activeName" type="card" class="config-tab" v-else>
        <a-tab-pane v-if="$isNotNull(widgetOptions.data)" :forceRender="true" key="first" tab="数据">
          <dynamicForm
            ref="dynamicFormData"
            :key="widgetOptions.uuid"
            :comIndex="widgetIndex"
            :widgetType="widgetOptions.widgetType || ''"
            :options="widgetOptions.data"
            @onChanged="(val) => widgetValueChanged('data', val)"
          />
        </a-tab-pane>
        <a-tab-pane v-if="$isNotNull(widgetOptions.setup) || $isNotNull(widgetOptions.collapse)"
          :key="$isNotNull(widgetOptions.data)?'second':'first'" tab="样式" :forceRender="true"
        >
          <dynamicForm
            :key="widgetOptions.uuid"
            :comIndex="widgetIndex"
            ref="formData"
            :widgetType="widgetOptions.widgetType || ''"
            :options="widgetOptions.setup"
            @onChanged="(val) => widgetValueChanged('setup', val)"
            @applyData="applyData"
            @styleChange="styleChange($event, widgets)"
          />
        </a-tab-pane>
      </a-tabs>
    </div>

    <content-menu
      :visible.sync="visibleContentMenu"
      :style-obj="styleObj"
      :widget="rightClickWidget"
      ref="contentMenu"
      @deletelayer="deletelayer"
      @copylayer="copylayer"
      @istopLayer="istopLayer"
      @setlowLayer="setlowLayer"
      @moveupLayer="moveupLayer"
      @movedownLayer="movedownLayer"
    />
  </div>
</template>

<script>
import {
  saveAnalysisTemplates,
  updateAnalysisTemplate,
  getAnalysisTemplatesDetails,
  templateExport,
  modelEditing
} from "@/api/template";
import { widgetTools, getToolByCode } from "./tools/index";
import widget from "./widget/widget.vue";
import dynamicForm from "./components/dynamicForm.vue";
import draggable from "vuedraggable";
import VueRulerTool from "vue-ruler-tool"; // 大屏设计页面的标尺插件
import contentMenu from "./components/contentMenu";
import { getToken } from "@/utils/auth";
import html2canvas from "html2canvas";
import { setDefaultValue } from '@/utils/modelMethods.js'
import moment from "moment"

export default {
  name: "screenDesigner",
  components: {
    draggable,
    VueRulerTool,
    widget,
    dynamicForm,
    contentMenu,
  },
  data() {
    return {
      timeRange: {},
      widgetTools, // 左侧工具栏的组件图标，将js变量加入到当前作用域
      widthLeftForTools: 137, // 左侧工具栏宽度
      widthLeftForToolsHideButton: 12, // 左侧工具栏折叠按钮宽度
      widthLeftForOptions: 300, // 右侧属性配置区
      widthPaddingTools: 18,
      toolIsShow: true, // 左侧工具栏是否显示
      scrollHeight: 0, // 工作区高度

      bigscreenWidth: 1200, // 大屏设计的大小
      bigscreenHeight: 1080,
      bigscreenScale: 100,

      // 工作台大屏画布，保存到表gaea_report_dashboard中
      dashboard: {
        id: null,
        width: 1200, // 大屏设计宽度
        height: 1080, // 大屏设计高度
        scale: 100, // 大屏缩放比例
        backgroundColor: "", // 大屏背景色
        backgroundImage: "", // 大屏背景图片
      },
      // 大屏画布中的组件
      widgets: [], // 工作区中拖放的组件
      screenOption: {},
      // 当前激活组件
      widgetIndex: -1, // -1大屏
      // 当前激活组件右侧配置属性
      widgetOptions: {
        setup: [], // 配置
        data: [], // 数据
        position: [], // 坐标
      },
      flagWidgetClickStopPropagation: false, // 点击组件时阻止事件冒泡传递到画布click事件上
      styleObj: {
        left: 0,
        top: 0,
      },
      visibleContentMenu: false,
      rightClickIndex: -1,
      rightClickWidget: {},
      activeName: "first",
      value: 0,
      saveCache: "",
      bodyWidth: document.body.clientWidth,
      deleteFlag: true,
      // 复制
      copyIndex: undefined,
      czList: [],
      cyList: [],
      // 批量操作
      batchList: [],
      // 定时器
      intval: null,
      filterCondition: []
    };
  },
  props: ["name", "zoom", "batchFlag"],
  provide() {
    return {
      getTimeRange: () => this.timeRange,
      getDashboardDynamicData: () => this.dashboard?.dynamicData,
      isbase: () => false,
      getIndex: () => this.widgetIndex,
      widgetUpdate: this.widgetUpdate,
      filterSearch: this.filterSearch,
      setFilterCondition: this.setFilterCondition,
      getFilterCondition: () => this.filterCondition,
    };
  },
  computed: {
    step() {
      return Number(100 / (this.bigscreenScaleInWorkbench * 100));
    },
    headers() {
      return {
        Authorization: getToken(), // 直接从本地获取token就行
      };
    },
    // 左侧折叠切换时，动态计算中间区的宽度
    middleWidth() {
      // 左侧工具栏折叠按钮宽度 + 右侧配置栏宽度
      let widthLeftAndRight = this.widthLeftForToolsHideButton + this.widthLeftForOptions;
      if (this.toolIsShow) {
        widthLeftAndRight += this.widthLeftForTools; // 左侧工具栏宽度
      } else {
        widthLeftAndRight -= 36; // 左侧工具栏宽度
      }
      let w = this.bodyWidth - widthLeftAndRight - 74
      return (w>1200?1200:w)
    },
    // 网页高度
    bodyHeight () {
      return document.body.clientHeight
    },
    middleHeight() {
      return this.bodyHeight - (86 + 26);
    },
    // 设计台按大屏的缩放比例
    bigscreenScaleInWorkbench() {
      return this.middleWidth / this.bigscreenWidth
    },
    workbenchTransform() {
      return `scale(${this.bigscreenScaleInWorkbench}, ${this.bigscreenScaleInWorkbench})`;
    },
    workbenchWidth() {
      return this.middleWidth/ this.bigscreenScaleInWorkbench + 'px'
    },
  },

  mounted() {
    const that = this;
    window.onbeforeunload = function (e) {
      console.log(that.$route, "----------modelDesign");
      if (that.$route.path === "/modelDesign") {
        e = e || window.event;
        if (e) {
          e.returnValue = "关闭提示";
        }
        return "关闭提示";
      } else {
        window.onbeforeunload = null;
      }
    };
    document.addEventListener('keydown', this.keydownHandle);
    // 如果是新的设计工作台
    this.initEchartData();

    window.onresize = () => {
      this.bodyWidth = document.body.clientWidth
      this.getScrollHeight()
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keydownHandle);
  },
  methods: {
    filterConditionRefresh() {
      let filterCondition = []
      try {
        this.widgets.forEach((v, i) => {
          if (v.type === 'widget-text-filter') {
            let list = v.value.data.dynamicData
            list.forEach(val => {
              val.value = v.value.data.text
              val.index = i
              val.name = val.dimension
              val.relation = 'AND'
            })
            filterCondition = filterCondition.concat(list)
          }
        })
      } catch (error) {
        console.log(error)      
      }
      this.filterCondition = filterCondition
      console.log(filterCondition, 'filterCondition')
    },
    setFilterCondition(index, value) {
      this.filterCondition.filter(v => v.index === index).forEach(v => {
        v.value = value
      })
    },
    filterSearch() {
      console.log(1111)
    },
    batchMove(params, value, isRight) {
      if(!this.batchList.length) {
        this.$message.error('请选择组件！')
      } else {
        console.log(this.batchList)
        this.batchList.forEach(v => {
          let n = this.widgets[v].value.position[params] - value
          if(n >= 0 && (!isRight || n <= (this.bigscreenWidth -this.widgets[v].value.position.width))) {
            this.widgets[v].value.position[params] = n
            this.widgets[v].options.position.forEach((el) => {
              if (el.name == params) {
                el.value = n;
              }
            });
          }
        })
      }
    },
    getStyleByCode(styleType, type) {
      let arr = getToolByCode(type).options.setup;
      console.log(arr)
      let obj = {}
      for (let i = 0; i < arr.length; i++) {
        const e = arr[i];
        if(e.dark) {
          obj[e.name] = styleType === 'dark'?e.dark:e.value
        } else if(e instanceof Array) {
          e.forEach(v => {
            v.list.forEach(val => {
              if(val.dark) {
                obj[val.name] = styleType === 'dark'?val.dark:val.value
              }
            })
          })
        }
      }
      return obj
    },
    widgetStyleChange(w, obj) {
      for (const k in obj) {
        w.value.setup[k] = obj[k]
        w.options.setup.forEach(v => {
          if(v.name === k) {
            v.value = obj[k]
          } else if(v instanceof Array) {
            v.forEach(val => {
              if(val.list&&val.list.length) {
                val.list.forEach(value => {
                  if(value.name === k) {
                    value.value = obj[k]
                  }
                })
              }
            })
          }
        })
      }
    },
    styleChange(styleType, arr) {
      arr.forEach(v => {
        // // 处理默认值
        let obj = this.getStyleByCode(styleType, v.type)
        this.widgetStyleChange(v, obj)
      })
    },
    handleYorZ(a, b) {
      let obj = a[a.length - 1]
      if(obj.type === 'add') {
        b.push({
          type: 'delete',
          value: this.widgets[obj.index]
        })
        this.widgets.splice(obj.index, 1)
      } else {
        this.widgets.push(obj.value)
        b.push({
          type: 'add',
          index: this.widgets.length -1
        })
      }
      a.pop()
    },
    keydownHandle(e) {
      if(e.key === 'Delete'&&this.widgets.length&&this.widgetIndex !== -1&&this.deleteFlag) {
        this.deletelayer(this.widgets[this.widgetIndex], true)
      }
      if (e.ctrlKey && e.key === 'z' && this.czList.length) {
        this.handleYorZ(this.czList, this.cyList)
        this.$message.success('撤销成功！')
      }
      if (e.ctrlKey && e.key === 'y' && this.cyList.length) {
        this.handleYorZ(this.cyList, this.czList)
        this.$message.success('恢复成功！')
      }
      // if (e.ctrlKey && e.key === 'c' && this.widgetIndex !== -1 && this.widgets[this.widgetIndex].type !== 'widget-time') {
      //   this.copyIndex = this.widgetIndex
      //   this.$message.success('复制成功！')
      // }
      // if (e.ctrlKey && e.key === 'v' && this.copyIndex !== undefined) {
      //   this.widgets.push(this.$deepclone(this.widgets[this.copyIndex]))
      //   this.czList.push({
      //     type: 'add',
      //     index: this.widgets.length -1
      //   })
      //   this.$message.success('粘贴成功！')
      // }
      if (e.ctrlKey && e.key === 'a' && this.batchFlag) {
        this.batchList = [...(new Array(this.widgets.length)).keys()]
      }
      if (this.widgetIndex !== -1) {
        let obj = this.$deepclone(this.widgets[this.widgetIndex].value.position)
        let fun = () => {
          const isDragObj = this.widgets[this.widgetIndex].options?.data[2];
          if (isDragObj && isDragObj.value.chartProperties) {
            this.widgets[
              this.widgetIndex
            ].options.data[2].value.chartProperties.isDrag = true;
          }      
          this.widgets[this.widgetIndex].value.position = obj;
          this.getScrollHeight()
        }
        if (e && e.keyCode == 38) {//上
          let t = obj.top - 20
          obj.top = t < 0?0:t
          fun()
        } else if (e && e.keyCode == 37) {//左
          let l = obj.left - 20
          obj.left = l < 0?0:l
          fun()
        } else if (e && e.keyCode == 40) {//下
          obj.top += 20
          fun()
        } else if (e && e.keyCode == 39) {//右
          let l = obj.left + 20
          let mw = Number(this.bigscreenWidth || 1200) || 1200
          l = (l + obj.width) > mw?(mw - obj.width):l
          obj.left = Math.floor(l/20) * 20
          fun()
        }
      }
    },
    // 计算工作区高度
    getScrollHeight() {
      this.scrollHeight = 0
      this.$nextTick(() => {
        let d = this.$refs['layout-middle']
        console.log(d.scrollHeight)
        this.scrollHeight = (d?d.scrollHeight:0)/this.bigscreenScaleInWorkbench
      })
    },
    dateDisabled(widget) {
      if (widget.code === "widget-time") {
        let obj = this.widgets.find((v) => v.type === "widget-time");
        return obj ? "pointer-events:none" : "";
      } else if (widget.code === "widget-filter") {
        let obj = this.widgets.find((v) => v.type === "widget-filter");
        return obj ? "pointer-events:none" : "";
      } else {
        return "";
      }
    },
    // 日期筛选
    timeChange(val) {
      this.timeRange = val;
    },
    async initEchartData() {
      const reportCode = this.$route.query.reportCode;
      if (reportCode) {
        const { code, data } = await getAnalysisTemplatesDetails({
          id: reportCode,
        });
        if (code != 200) return;
        if (this.name !== data.name) this.$emit("nameChange", data.name);
        let widgets = data.canvas.widgets || []
        widgets = widgets.filter(v => v.type !== 'widget-filter')
        const processData = this.handleInitEchartsData(widgets);
        const screenData = this.handleBigScreen({...data.canvas, ...(data.customOptions || {})});
        this.widgets = processData;
        this.filterConditionRefresh()
        this.dashboard = screenData;
        modelEditing(reportCode)
        this.intval = setInterval(() => {
          modelEditing(reportCode)
        }, 10000);
      } else {
        // 时间控件默认展示
        this.widgetOnDragged({
          l: 820,
          t: 100
        }, 'widget-time', true)
        this.handleBigScreen({});
      }
      this.bigscreenWidth = this.dashboard.width;
      this.bigscreenHeight = this.dashboard.height;
      this.saveCache = JSON.stringify(this.widgets) + this.name;
      this.getScrollHeight()
    },
    goBackHandle() {
      if (this.saveCache !== JSON.stringify(this.widgets) + this.name) {
        this.$confirm({
          title: "确认离开吗",
          content: "系统可能不会保存您所做的更改。",
          onOk: () => {
            this.$router.go(-1);
          },
          onCancel() {},
        });
      } else {
        this.$router.go(-1);
      }
    },
    handleBigScreen(data) {
      let optionScreen = getToolByCode("screen").options;
      let setup = optionScreen.setup;
      let optionsData = optionScreen.data;
      for (const key in data) {
        for (let i = 0; i < setup.length; i++) {
          if (key == setup[i].name) {
            setup[i].value = data[key];
          }
        }
      }
      optionsData[1].value = data.dynamicData || {};
      this.screenOption = optionScreen
      this.setOptionsOnClickScreen();
      return {
        backgroundColor: (data && data.backgroundColor) || "",
        backgroundImage: (data && data.backgroundImage) || "",
        height: (data && data.height) || "1080",
        width: (data && data.width) || "1200",
        dynamicData: data.dynamicData,
        style: data.style || 'normal'
      };
    },
    handleInitEchartsData(widgets) {
      const widgetsData = [];
      let timeObj = widgets.find((v) => v.type === "widget-time");
      let timeSelector, timeValue = undefined;
      if (timeObj) {
        timeSelector = timeObj.value.setup.timeSelector || undefined
        timeValue = timeObj.value.setup.value
        if(timeSelector) {
          timeValue = this.$timeSelectorToDate(timeSelector);
          timeObj.options.setup[0].value = [...timeValue];
          timeObj.value.setup.value = timeValue;
        }
        this.timeRange = {
          from: timeValue[0].format?timeValue[0].format('YYYY-MM-DD'):moment(timeValue[0]).format('YYYY-MM-DD'),
          to: timeValue[1].format?timeValue[1].format('YYYY-MM-DD'):moment(timeValue[1]).format('YYYY-MM-DD'),
          timeSelector: timeSelector || undefined
        };
      }
      for (let i = 0; i < widgets.length; i++) {
        let obj = {
          type: widgets[i].type,
          value: {
            setup: widgets[i].value.setup,
            data: widgets[i].value.data,
            position: widgets[i].value.position,
          }
        };
        // 第一次加载请求数据
        let dynamicData = obj.value.data.dynamicData
        if(dynamicData&&dynamicData.chartProperties) {
          dynamicData.chartProperties.isVerified = true
        }
        const tool = this.$deepclone(getToolByCode(widgets[i].type));
        obj.options = this.handleOptionsData(widgets[i].value, tool.options);
        if (timeSelector && obj.dynamicDataParam && obj.dynamicDataParam.globalDateRang) {
          obj.dynamicDataParam.globalDateRang = {
            from: value[0],
            to: value[1],
            timeSelector: timeSelector,
          };
        }
        if(timeObj&&dynamicData?.contextData?.globalDateRang) {
          dynamicData.contextData.globalDateRang = this.timeRange
        }
        // 转独立日期
        let contextData = dynamicData?.contextData;
        if (contextData?.dateRang?.timeSelector) {
          let val = contextData.dateRang.timeSelector;
          let value = this.$timeSelectorToDate(val);
          contextData.dateRang = {
            from: value[0],
            to: value[1],
            timeSelector: val,
          };
        }
        widgetsData.push(obj);
      }
      console.log(widgetsData, '11111111111111')
      return widgetsData;
    },
    handleOptionsData(data, option) {
      for (const key in data.setup) {
        for (let i = 0; i < option.setup.length; i++) {
          let item = option.setup[i];
          if (Object.prototype.toString.call(item) == "[object Object]") {
            if (key == option.setup[i].name) {
              option.setup[i].value = data.setup[key];
            }
          } else if (Object.prototype.toString.call(item) == "[object Array]") {
            for (let j = 0; j < item.length; j++) {
              const list = item[j].list;
              list.forEach((el) => {
                if (key == el.name) {
                  el.value = data.setup[key];
                }
              });
            }
          }
        }
      }
      // position
      for (const key in data.position) {
        for (let i = 0; i < option.position.length; i++) {
          if (key == option.position[i].name) {
            option.position[i].value = data.position[key];
          }
        }
      }
      // data
      for (const key in data.data) {
        for (let i = 0; i < option.data.length; i++) {
          if (key == option.data[i].name) {
            option.data[i].value = data.data[key];
          }
        }
      }
      return option;
    },
    dataVerify() {
      if (!this.widgets || this.widgets.length == 0) {
        this.$message.error("请添加组件");
        return false;
      }
      let filter = this.widgets.find((v) => v.type === "widget-text-filter"&&!v.value.data.dynamicData.length);
      if (filter) {
        this.$message.error("请设置筛选维度");
        return false;
      }
      let date = this.widgets.find((v) => v.type === "widget-time");
      if (!date) {
        let card = this.widgets.find((v) => v.type === "widget-card");
        let fun = () => {
          let arr = this.widgets.filter(
            (v) =>
              v.type !== "widget-card" &&
              v.type !== "widget-text" &&
              v.type !== "widget-image"
          );
          let flag = false;
          for (let i = 0; i < arr.length; i++) {
            const element = arr[i];
            let dateRang =
              element.value?.data?.dynamicData?.contextData?.dateRang || {};
            if (!dateRang.to || !dateRang.from) {
              flag = true;
              break;
            }
          }
          return flag;
        };
        if (card || fun()) {
          this.$message.error("请添加日期组件");
          return false;
        }
      }
      /**
       * 解决全局globalOptions赋值未生效到单个组件
       */
      let globalOptions;
      if (this.dashboard?.dynamicData?.contextData) {
        globalOptions = {
          globalAccountIds: this.dashboard.dynamicData.contextData.accountIds,
          globalDataSource: this.dashboard.dynamicData.contextData.datasource,
          globalFilterType: this.dashboard.dynamicData.contextData.filterType,
          globalTableId: this.dashboard.dynamicData.contextData.tableId,
        }
      }
      let widgets = JSON.parse(JSON.stringify(this.widgets));
      for (let i = 0; i < widgets.length; i++) {
        let obj = widgets[i].value.data;
        let dynamicDataParam = obj.dataType === "dynamicData" ? obj.dynamicData || null : null;
        widgets[i].dynamicDataParam = dynamicDataParam?{
          ...dynamicDataParam.contextData,
          type: dynamicDataParam.chartType,
          globalOptions
        }: null;
      }
      return widgets;
    },
    // 保存数据
    async saveData() {
      if (!this.name) {
        this.$emit('nameVisible', 'save')
        return;
      }
      let widgets = this.dataVerify();
      if (!widgets) {
        return;
      }
      const params = {
        canvas: {
          reportCode: this.$route.query.reportCode,
          width: this.dashboard.width,
          height: this.dashboard.height,
          backgroundColor: this.dashboard.backgroundColor,
          backgroundImage: this.dashboard.backgroundImage,
          dynamicData: this.dashboard.dynamicData,
          widgets,
        },
        customOptions: {
          style: this.dashboard.style
        },
        name: this.name,
      };

      const reportCode = this.$route.query.reportCode;
      this.$emit("saveLoading", true);
      let api = reportCode ? updateAnalysisTemplate : saveAnalysisTemplates;
      api(params, reportCode)
        .then(({ data }) => {
          if (!reportCode) {
            gtag("event", "create_model", {
              modelName: this.name,
            });
          }
          // GA统计指标
          this.sendGA(widgets);
          this.$message.success("保存成功！");
          this.saveCache = JSON.stringify(this.widgets) + this.name;
          if (!reportCode) {
            this.$router.replace({
              name: "modelDesign",
              query: {
                reportCode: data,
                name: this.name,
              },
            });
          }
        })
        .finally((v) => this.$emit("saveLoading", false));
    },
    sendGA(widgets) {
      for (let i = 0; i < widgets.length; i++) {
        const obj = widgets[i];
        if (obj.dynamicDataParam && obj.dynamicDataParam.fields) {
          for (let n = 0; n < obj.dynamicDataParam.fields.length; n++) {
            gtag("event", "model_field", {
              model_field: obj.dynamicDataParam.fields[n],
              modelName: this.name,
            });
          }
        }
      }
    },
    // 预览
    viewScreen() {
      if (!this.name) {
        this.$emit('nameVisible', 'view')
        return;
      }
      let widgets = this.dataVerify();
      if (!widgets) {
        return;
      }
      localStorage.setItem(
        "viewCanvas",
        JSON.stringify({
          name: this.name,
          width: this.dashboard.width,
          height: this.dashboard.height,
          backgroundColor: this.dashboard.backgroundColor,
          backgroundImage: this.dashboard.backgroundImage,
          dynamicData: this.dashboard.dynamicData,
          customOptions: {
            style: this.dashboard.style
          },
          widgets,
        })
      );
      let routeUrl = this.$router.resolve({
        path: "/modelViewer",
      });
      window.open(routeUrl.href, "_blank");
    },
    //  导出
    async exportDashboard() {
      if (!this.name) {
        this.$message.error("名称不能为空");
        return;
      }
      let scrollHeight =
        this.$refs["workbench-container"].children[0].scrollHeight;
      let canvasID = this.$refs["download-area"];
      canvasID.style.height = scrollHeight + "px";
      this.$emit("exportLoading", true);
      html2canvas(canvasID).then((canvas) => {
        let dom = document.body.appendChild(canvas);
        dom.style.display = "none";
        document.body.removeChild(dom);
        let blob = this.dataURLToBlob(dom.toDataURL("image/png"));
        URL.revokeObjectURL(blob);
        // 去掉标尺
        let img = new Image();
        img.src = window.URL.createObjectURL(blob);
        let dom1 = document.body.appendChild(img);
        dom1.style.display = "none";
        document.body.removeChild(dom1);
        let canvas1 = document.createElement("canvas");
        let cxt1 = canvas1.getContext("2d");
        img.onload = async () => {
          canvasID.style.height = "auto";
          canvas1.height = img.height - 18;
          canvas1.width = img.width - 18;
          cxt1.drawImage(img, -18, -18, img.width, img.height);
          let dom = document.body.appendChild(canvas1);
          dom.style.display = "none";
          document.body.removeChild(dom);
          let blob1 = this.dataURLToBlob(dom.toDataURL("image/png"));
          URL.revokeObjectURL(blob1);
          let widgets = JSON.parse(JSON.stringify(this.widgets));
          widgets = widgets
            .filter((v) => v.value?.data?.dataType === "dynamicData")
            .map((v) => ({
              dynamicDataParam: {
                ...(v.value.data?.dynamicData || {}),
                ...(v.value.data?.dynamicData?.contextData
                  ? v.value.data.dynamicData.contextData
                  : {}),
              },
              type: v.type,
            }));
          let param = new FormData(); // 创建form对象
          param.append("file", blob1); // 通过append向form对象添加数据
          param.append(
            "template",
            JSON.stringify({
              name: this.name,
              widgets,
            })
          ); // 添加form表单中其他数据
          this.$emit("exportLoading", true);
          const res = await templateExport(param);
          if (res.code === 200) {
            this.$message.success("数据导出中，请稍后在【下载中心】查看");
          }
          this.$emit("exportLoading", false);
        };
      });
    },
    dataURLToBlob(dataurl) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr, { type: mime }]);
    },
    // 上传成功的回调
    handleUpload(response, file, fileList) {
      //清除el-upload组件中的文件
      this.$refs.upload.clearFiles();
      //刷新大屏页面
      this.initEchartData();
      if (response.code == "200") {
        this.$message({
          message: "导入成功！",
          type: "success",
        });
      } else {
        this.$message({
          message: response.message,
          type: "error",
        });
      }
    },
    handleError(err) {
      this.$message({
        message: "上传失败！",
        type: "error",
      });
    },
    // 拖动一个组件放到工作区中去，在拖动结束时，放到工作区对应的坐标点上去
    widgetOnDragged(evt, widgetType, flag) {
      let t,l = 0
      // 复制一个组件
      let tool = getToolByCode(widgetType);
      let position = tool.options.position || []
      let obj = position.find(v => v.name === 'width')
      let d = this.$refs['layout-middle']
      if(!flag) {
        l = (evt.originalEvent.x-(this.toolIsShow?185:12))/this.bigscreenScaleInWorkbench
        t = (evt.originalEvent.y + d.scrollTop -86)/this.bigscreenScaleInWorkbench
        l = Math.round((l<0?0:l)/20) * 20
        t = Math.round((t<0?0:t)/20) * 20
        let width = obj?.value || 0
        if((l + width) >1200) {
          l = Math.round(1200 - width)
        }
      } else {
        t = evt.t
        l = evt.l
      }
      let widgetJson = {
        type: widgetType,
        value: {
          setup: {},
          data: {},
          position: {
            width: 0,
            height: 0,
            left: l,
            top: t,
            zIndex: 0,
          },
        },
        options: tool.options,
      };
      // 处理默认值
      const widgetJsonValue = this.$deepclone(this.handleDefaultValue(widgetJson));
      this.styleChange(this.dashboard.style, [widgetJsonValue])
      // 将选中的复制组件，放到工作区中去
      // console.log(widgetJsonValue, 'widgetJsonValue')
      this.widgets.push(widgetJsonValue);
      this.czList.push({
        type: 'add',
        index: this.widgets.length - 1
      })
      if(!this.batchFlag&&!flag) {
        this.$nextTick(() => {
          // 激活新组件的配置属性
          this.widgetsClick(this.widgets.length - 1)
        })
      }
    },

    // 对组件默认值处理
    handleDefaultValue(widgetJson) {
      for (const key in widgetJson) {
        if (key == "options") {
          // collapse、data、position、setup
          // setup 处理
          for (let i = 0; i < widgetJson.options.setup.length; i++) {
            const item = widgetJson.options.setup[i];
            if (Object.prototype.toString.call(item) == "[object Object]") {
              widgetJson.value.setup[item.name] = item.value;
            } else if (
              Object.prototype.toString.call(item) == "[object Array]"
            ) {
              for (let j = 0; j < item.length; j++) {
                const list = item[j].list;
                list.forEach((el) => {
                  widgetJson.value.setup[el.name] = el.value;
                });
              }
            }
          }
          // position
          for (let i = 0; i < widgetJson.options.position.length; i++) {
            const item = widgetJson.options.position[i];
            if (item.value) {
              widgetJson.value.position[item.name] = item.value;
            }
          }
          // data 处理
          if (widgetJson.options.data && widgetJson.options.data.length > 0) {
            for (let i = 0; i < widgetJson.options.data.length; i++) {
              const item = widgetJson.options.data[i];
              if (item.value) {
                widgetJson.value.data[item.name] = item.value;
              }
            }
          }
        }
      }
      return widgetJson;
    },
    // 如果是点击大屏设计器中的底层，加载大屏底层属性
    setOptionsOnClickScreen() {
      console.log('setOptionsOnClickScreen')
      this.widgetIndex = -1
      // 选中不同的组件 右侧都显示第一栏
      this.activeName = "first";
      this.widgetOptions = this.screenOption
    },

    // 如果是点击某个组件，获取该组件的配置项
    widgetsOnActivated(obj) {
      // 拖动组件的时候重新获取数据
      if (this.widgetIndex !== obj.index) this.activeName = "first";
      if (obj.index < 0 || obj.index >= this.widgets.length) return;
      this.widgetsClick(obj.index)
      const isDragObj = this.widgets[obj.index].options?.data[2];
      if (isDragObj && isDragObj.value.chartProperties) {
        this.widgets[
          obj.index
        ].options.data[2].value.chartProperties.isDrag = true;
      }
      this.widgets[obj.index].value.position = obj;
      this.widgets[obj.index].options.position.forEach((el) => {
        for (const key in obj) {
          if (el.name == key) {
            el.value = obj[key];
          }
        }
      });
      this.getScrollHeight()
    },
    widgetsClick(index) {
      if(this.widgetIndex !== index) {
        this.activeName = "first";
        this.widgetIndex = index;
        const draggableArr = this.$refs.widgets;
        for (let i = 0; i < draggableArr.length; i++) {
          this.$refs.widgets[i].$refs.draggable.setActive(i == index);
        }
        this.$store.commit("modelDesign/SET_CURRENT_TEMP_INDEX", index);
        this.widgetOptions = {
          ...this.$deepclone(this.widgets[index]["options"]),
          widgetType: this.widgets[index].type
        }
      }
    },
    handleMouseDown() {
      const draggableArr = this.$refs.widgets || [];
      console.log(draggableArr)
      for (let i = 0; i < draggableArr.length; i++) {
        this.$refs.widgets[i].$refs.draggable.setActive(false);
      }
    },
    applyData(val) {
      console.log(val, this.widgets[this.widgetIndex], 'applyDataapplyDataapplyData')
      if(this.widgets[this.widgetIndex].type === 'widget-button') {
        let widgets = JSON.parse(JSON.stringify(this.widgets))
        this.$store.commit("modelDesign/SET_APPLY_LOADING", true);
        setTimeout(() => {
          this.$store.commit("modelDesign/SET_APPLY_LOADING", false);
        }, 500)
        widgets.forEach((v) => {
          let { contextData, chartProperties } = v.value.data.dynamicData || {}
          if (contextData){
            chartProperties.isVerified = true
          }
        });
        this.widgets = []
        
        this.$nextTick(() => {
          this.widgets = widgets
        })
        return;
      }
      if(this.widgets[this.widgetIndex].value?.data?.dynamicData?.chartProperties) {
        console.log('isVerified')
        this.widgets[this.widgetIndex].value.data.dynamicData.chartProperties.isVerified = true
      }
      this.widgetValueChanged('setup', val)
    },
    widgetUpdate(key, obj, index) {
      console.log(key, obj, index, 'widgetUpdate')
      if(!index&&index !== 0) {
        let val = this.$deepclone({
          ...setDefaultValue(this.widgetOptions[key]),
          ...obj
        })
        this.setDefaultValue(this.widgetOptions[key], val);
        if (this.widgets[this.widgetIndex]) {
          this.widgets[this.widgetIndex].value[key] = this.$deepclone(val);
          this.setDefaultValue(this.widgets[this.widgetIndex].options[key], val);
        }
      } else if (this.widgets[index]) {
        let val = this.$deepclone({
          ...setDefaultValue(this.widgets[index].options[key]),
          ...obj
        })
        this.widgets[index].value[key] = this.$deepclone(val);
        this.setDefaultValue(this.widgets[index].options[key], val);
        if(this.widgetIndex === index) {
          this.widgetOptions[key] = this.widgets[index].options[key]
        }
      }
    },
    // 将当前选中的组件，右侧属性值更新
    widgetValueChanged(key, val) {
      console.log(key, val, "======================", this.widgetIndex);
      // debugger;
      // 编辑时
      if (this.widgetIndex == -1) {
        if (key === "data") {
          // 全局应用
          let { datasource, tableId, filterType, accountIds } = val.dynamicData?.contextData || {}
          let {
            datasource: oDatasource,
            tableId: oTableId,
          } = this.dashboard.dynamicData?.contextData || {}
          let mediaCodeflag =  oDatasource?.mediaCode !== datasource?.mediaCode
          let tableIdFlag = oTableId !== tableId
          this.widgetOptions.data[1].value = val.dynamicData;
          this.dashboard.dynamicData = val.dynamicData;
          let widgets = JSON.parse(JSON.stringify(this.widgets))
          this.$store.commit("modelDesign/SET_APPLY_LOADING", true);
          setTimeout(() => {
            this.$store.commit("modelDesign/SET_APPLY_LOADING", false);
          }, 500)
          widgets.forEach((v) => {
            let { contextData, chartProperties } = v.value.data.dynamicData || {}
            if (contextData){
              if((!contextData.datasource&&mediaCodeflag) || (!contextData.datasource&&!contextData.tableId&&tableIdFlag)) {
                v.value.data.dynamicData = {}
                if(v.type === 'widget-table') {
                  v.value.setup.dynamicAddTable = []
                }
                v.options = getToolByCode(v.type).options
              }
              chartProperties.isVerified = true
            }
          });
          this.widgets = []
          
          this.$nextTick(() => {
            this.widgets = widgets
          })
        } else {
          let newSetup = new Array();
          this.dashboard = {
            ...this.dashboard,
            ...val,
          };
          if (this.bigscreenWidth != this.dashboard.width) {
            this.bigscreenWidth = this.dashboard.width;
          }
          if (this.bigscreenHeight != this.dashboard.height) {
            this.bigscreenHeight = this.dashboard.height;
          }
          if (this.bigscreenScale != this.dashboard.scale) {
            this.bigscreenScale = this.dashboard.scale;
          }
          this.widgetOptions.setup.forEach((el) => {
            if (el.name == "width") {
              el.value = this.bigscreenWidth;
            } else if (el.name == "height") {
              el.value = this.bigscreenHeight;
            } else if (el.name == "scale") {
              el.value = this.bigscreenScale;
            } else if (el.name == "backgroundColor") {
              el.value = this.dashboard.backgroundColor || '';
            } else if (el.name == "style") {
              el.value = this.dashboard.style || '';
            }
            newSetup.push(el);
          });
          this.widgetOptions.setup = newSetup;
        }
      } else {
        // 组件应用数据时；
        let nowWdt = this.widgets[this.widgetIndex]
        if (nowWdt) {
          if(nowWdt.type === 'widget-time') {
            let oldFs = nowWdt.value[key].fontSize
            console.log(oldFs, val.fontSize)
            if(oldFs == val.fontSize) {
              this.widgets.forEach((v) => {
                let { contextData, chartProperties } = v.value.data.dynamicData || {}
                if (contextData){
                  contextData.globalDateRang.from = val.value[0]
                  contextData.globalDateRang.to = val.value[1]
                  contextData.globalDateRang.timeSelector = val.timeSelector
                  chartProperties.isVerified = true
                }
              });
            }
          }
          if(nowWdt.type === 'widget-text-filter') {
            this.$nextTick(() => {
              this.filterConditionRefresh()
            })
          }
          nowWdt.value[key] = this.$deepclone(val);
          this.setDefaultValue(nowWdt.options[key], val);
          this.widgetOptions = {
            ...this.$deepclone(nowWdt["options"]),
            widgetType: nowWdt.type
          }
        }
      }
    },
    rightClick(event, index, obj) {
      this.rightClickIndex = index;
      this.rightClickWidget = obj;
      const left = event.clientX;
      const top = event.clientY;
      if (left || top) {
        this.styleObj = {
          left: left + "px",
          top: top + "px",
          display: "block",
        };
      }
      this.visibleContentMenu = true;
      return false;
    },
    setDefaultValue(options, val) {
      for (let i = 0; i < options.length; i++) {
        if (Object.prototype.toString.call(options[i]) == "[object Object]") {
          for (const k in val) {
            if (options[i].name == k) {
              options[i].value = val[k];
            }
          }
        } else if (
          Object.prototype.toString.call(options[i]) == "[object Array]"
        ) {
          for (let j = 0; j < options[i].length; j++) {
            const list = options[i][j].list;
            for (let z = 0; z < list.length; z++) {
              for (const k in val) {
                if (list[z].name == k) {
                  list[z].value = val[k];
                }
              }
            }
          }
        }
      }
    },
    // 删除
    deletelayer(widget, flag) {
      this.deleteFlag = false
      this.$confirm( {
        title:"是否删除所选图层?",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        onOk:() => {
          return new Promise((resolve, reject) => {
            if (widget.type === "widget-time") {
              this.timeRange = {};
            }
            this.czList.push({
              type: 'delete',
              value: this.widgets[flag?this.widgetIndex:this.rightClickIndex]
            })
            this.widgets.splice(flag?this.widgetIndex:this.rightClickIndex, 1);
            this.setOptionsOnClickScreen()
            this.$message.success( "删除成功");
            this.deleteFlag = true
            this.filterConditionRefresh()
            resolve();
          })
        },
        onCancel:()=>{
          this.$message.info( "已取消删除");
          this.deleteFlag = true
        }
      })
    },
    // 复制
    copylayer() {
      let obj = this.$deepclone(this.widgets[this.rightClickIndex]);
      let dynamicData = obj.value.data.dynamicData
      if(dynamicData&&dynamicData.chartProperties) {
        dynamicData.chartProperties.isVerified = true
      }
      this.widgets.push(obj);
      this.czList.push({
        type: 'add',
        index: this.widgets.length -1
      })
      this.filterConditionRefresh()
    },
    // 置顶
    istopLayer() {
      if (this.rightClickIndex + 1 < this.widgets.length) {
        const temp = this.widgets.splice(this.rightClickIndex, 1)[0];
        this.widgets.push(temp);
        this.filterConditionRefresh()
      }
    },
    // 置底
    setlowLayer() {
      if (this.rightClickIndex != 0) {
        this.widgets.unshift(this.widgets.splice(this.rightClickIndex, 1)[0]);
        this.filterConditionRefresh()
      }
    },
    // 上移一层
    moveupLayer() {
      if (this.rightClickIndex != 0) {
        this.widgets[this.rightClickIndex] = this.widgets.splice(
          this.rightClickIndex - 1,
          1,
          this.widgets[this.rightClickIndex]
        )[0];
      } else {
        this.widgets.push(this.widgets.shift());
      }
      this.filterConditionRefresh()
    },
    // 下移一层
    movedownLayer() {
      if (this.rightClickIndex != this.widgets.length - 1) {
        this.widgets[this.rightClickIndex] = this.widgets.splice(
          this.rightClickIndex + 1,
          1,
          this.widgets[this.rightClickIndex]
        )[0];
      } else {
        this.widgets.unshift(this.widgets.splice(this.rightClickIndex, 1)[0]);
      }
      this.filterConditionRefresh()
    },
  },
  destroyed() {
    if(this.intval) {
      clearInterval(this.intval)
    }
  }
};
</script>

<style scoped lang="less">
.mr10 {
  margin-right: 10px;
}

.ml20 {
  margin-left: 20px;
}

.border-right {
  border-right: 1px solid #273b4d;
}

.border-left {
  border-left: 1px solid #273b4d;
}

.el-icon-arrow-down {
  font-size: 10px;
}

.is-active {
  background: #31455d !important;
  color: #bfcbd9 !important;
}
.cont-tool-bar {
  border-bottom: 1px solid #e1e8f9;
  .tool-bar {
    padding-top: 18px;
    display: inline-block;
    padding-bottom: 16px;
  }
}
.layout {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  padding-bottom: 26px;

  .layout-left {
    width: 96px;
    display: inline-block;
    height: 100%;
    box-sizing: content-box;
    border: 0px;
    padding-left: 24px;
    padding-right: 12px;
    // background-color: #263445;

    //工具栏一个元素
    .tools-item {
      display: flex;
      position: relative;
      width: 100%;
      align-items: center;
      -webkit-box-align: center;
      padding-left: 4px;
      cursor: pointer;
      font-size: 14px;
      margin-bottom: 10px;
      margin-top: 10px;
      height: 36px;
      border-radius: 6px;
      border: 1px dashed transparent;
      &:hover {
        background: #fbfcfe;
        border: 1px dashed #cbd5ee;
      }
      &:active {
        border-color: #22ac35;
        .tools-item-text {
          color: #22ac35;
        }
      }
      .tools-item-icon {
        margin-right: 10px;
        font-size: 16px;
      }
      .tools-item-text {
        color: #677392;
      }
    }
  }

  .layout-left-fold {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 100%;
    font-size: 12px;
    overflow: hidden;
    height: calc(100vh - 112px);
    align-items: center;
    // background-color: #242a30;
    cursor: pointer;
    i {
      margin-left: -4px;
      font-size: 18px;
      width: 18px;
      height: 23px;
      color: #bfcbd9;
    }
    i.el-icon-arrow-right {
      margin-left: -6px;
    }
  }

  .layout-middle {
    flex-grow: 1;
    position: relative;
    height: 100%;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    align-items: center;
    vertical-align: middle;
    margin-right: 12px;
    text-align: center;
    border: 1px solid #cbd5ee;
    border-radius: 6px;
    .top-button {
      display: flex;
      flex-direction: row;
      height: 40px;
      line-height: 40px;
      margin-left: 9px;

      .btn {
        color: #788994;
        width: 55px;
        text-align: center;
        display: block;
        cursor: pointer;

        .el-icon-arrow-down {
          transform: rotate(0deg);
          -ms-transform: rotate(0deg); /* IE 9 */
          -moz-transform: rotate(0deg); /* Firefox */
          -webkit-transform: rotate(0deg); /* Safari 和 Chrome */
          -o-transform: rotate(0deg); /* Opera */
          transition: all 0.4s ease-in-out;
        }

        &:hover {
          background: rgb(25, 29, 34);

          .el-icon-arrow-down {
            transform: rotate(180deg);
            -ms-transform: rotate(180deg); /* IE 9 */
            -moz-transform: rotate(180deg); /* Firefox */
            -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
            -o-transform: rotate(180deg); /* Opera */
            transition: all 0.4s ease-in-out;
          }
        }
      }
    }

    .workbench-container {
      position: relative;
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      margin: 0 auto;
      padding: 0;
      .vueRuler {
        width: 100%;
        padding: 18px 0px 0px 18px;
        overflow-y: auto;
      }
      .vue-ruler-content {
        width: 100%;
      }
      .workbench {
        // background-color: #fbfcfe;
        background-color: #fbfcfe;
        position: relative;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        margin: 0;
        padding: 0;
        .line {
          position: absolute;
          height: 100%;
          width: 1px;
          top: 0;
          z-index: -1000;
        }
        .ve-line {
          position: absolute;
          height: 1px;
          width: 100%;
          left: 0;
          z-index: -1000;
        }
      }
    }

    .bottom-text {
      width: 100%;
      color: #a0a0a0;
      font-size: 16px;
      position: absolute;
      bottom: 20px;
    }
  }

  .layout-right {
    display: inline-block;
    height: calc(100vh - 112px);
    padding: 16px 0px 16px 16px;
    border-radius: 16px;
    border: 1px solid #cbd5ee;
  }
  .config-tab {
    /deep/ .ant-tabs-bar {
      border: 0;
    }
    /deep/ .ant-tabs-tab {
      border: 0;
      border-radius: 8px;
      background: #f3f6fe;
      color: #2d3446;
      &.ant-tabs-tab-active {
        background: #ffffff;
        color: #22ac35;
        font-weight: 500;
      }
    }
  }
  /deep/ .el-tabs--border-card {
    border: 0;

    .el-tabs__header {
      .el-tabs__nav {
        .el-tabs__item {
          // background-color: #242f3b;
          border: 0px;
        }

        .el-tabs__item.is-active {
          // background-color: #31455d;
        }
      }
    }

    .el-tabs__content {
      // background-color: #242a30;
      height: calc(100vh - 39px);
      overflow-x: hidden;
      overflow-y: auto;

      .el-tab-pane {
        color: #bfcbd9;
      }

      &::-webkit-scrollbar {
        width: 5px;
        height: 14px;
      }

      &::-webkit-scrollbar-track,
      &::-webkit-scrollbar-thumb {
        border-radius: 1px;
        border: 0 solid transparent;
      }

      &::-webkit-scrollbar-track-piece {
        /*修改滚动条的背景和圆角*/
        background: #29405c;
        -webkit-border-radius: 7px;
      }

      &::-webkit-scrollbar-track {
        box-shadow: 1px 1px 5px rgba(116, 148, 170, 0.5) inset;
      }

      &::-webkit-scrollbar-thumb {
        min-height: 20px;
        background-clip: content-box;
        box-shadow: 0 0 0 5px rgba(116, 148, 170, 0.5) inset;
      }

      &::-webkit-scrollbar-corner {
        background: transparent;
      }

      /*修改垂直滚动条的样式*/
      &::-webkit-scrollbar-thumb:vertical {
        background-color: #00113a;
        -webkit-border-radius: 7px;
      }

      /*修改水平滚动条的样式*/
      &::-webkit-scrollbar-thumb:horizontal {
        background-color: #00113a;
        -webkit-border-radius: 7px;
      }
    }
  }
}

ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav {
  width: 40px;
  padding: 0;
  list-style: none;
  /* overflow: hidden; */
}

.nav {
  zoom: 1;
}

.nav:before,
.nav:after {
  content: "";
  display: table;
}

.nav:after {
  clear: both;
}

.nav > li {
  width: 55px;
  text-align: left;
  position: relative;
}

.nav > li a {
  float: left;
  padding: 12px 30px;
  color: #999;
  font: bold 12px;
  text-decoration: none;
}

.nav > li:hover {
  color: #788994;
}

.nav > li ul {
  visibility: hidden;
  position: absolute;
  z-index: 1000;
  list-style: none;
  left: 0;
  padding: 0;
  background-color: rgb(36, 42, 48);
  opacity: 0;
  _margin: 0;
  width: 120px;
  transition: all 0.2s ease-in-out;
}

.nav > li:hover > ul {
  opacity: 1;
  visibility: visible;
  margin: 0;

  li:hover {
    background-color: rgb(25, 29, 34);
  }
}

.nav ul li {
  float: left;
  display: block;
  border: 0;
  width: 100%;
  font-size: 12px;
}

.nav ul a {
  padding: 10px;
  width: 100%;
  display: block;
  float: none;
  height: 120px;
  border: 1px solid #30445c;
  background-color: rgb(25, 29, 34);
  transition: all 0.2s ease-in-out;
}

.nav ul a:hover {
  border: 1px solid #3c5e88;
}

.nav ul li:first-child > a:hover:before {
  border-bottom-color: #04acec;
}

.nav ul ul {
  top: 0;
  left: 120px;
  width: 400px;
  height: 300px;
  overflow: auto;
  padding: 10px;
  _margin: 0;
}

.nav ul ul li {
  width: 120px;
  height: 120px;
  margin-right: 3px;
  display: block;
  float: left;
}

.nav .item {
  padding: 5px;
}

/deep/ .vue-ruler-h {
  opacity: 0.3;
}

/deep/ .vue-ruler-v {
  opacity: 0.3;
}
/deep/ .layout-right {
  .ant-tabs {
    overflow: inherit;
  }
  .ant-tabs .ant-tabs-top-content,
  .ant-tabs .ant-tabs-bottom-content {
    height: calc(100vh - 200px);
    overflow-y: scroll;
    overflow-x: inherit;
  }
}
.postion-btns {
  position: relative;
  height: 152px;
  width: 100%;
  .line {
    height: 88px;
    position: absolute;
    width: 1px;
    left: 50%;
    background: #00113a;
    top: 32px;
    margin-left: -8.5px;
  }
  .vline {
    width: 88px;
    position: absolute;
    height: 1px;
    top: 50%;
    background: #00113a;
    left: 90px;
    margin-top: -0.5px;
  }
  .ant-btn {
    position: absolute;
    width: 90px;
  }
  .top, .bottom {
    left: 50%;
    margin-left: -52px;
    top: 0px;
  }
  .left, .right {
    top: 60px;
  }
  .left {
    left: 0px;
  }
  .right {
    right: 16px;
  }
  .bottom {
    top: 120px;
  }
}
</style>